import React from "react";
import { Helmet } from "react-helmet";
import { APP_NAME } from "../../app.config";

function Footer() {
  return (
    <>
      <Helmet>
        <script>{`
                $(document).ready(function() {
                    let value = new Date().getFullYear();
                    document.getElementById("Footer_DATE").innerHTML = value;
                });
        `}</script>
      </Helmet>
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              Copyright &copy; <label id='Footer_DATE'></label> <b>{APP_NAME}</b> | All Rights Reserved
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
